// src/v2/lib/weekUtils.ts

export const WEEKDAYS_LETTER = ["M", "T", "W", "T", "F", "S", "S"] as const;
export const WEEKDAYS_SHORT = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] as const;
export const WEEKDAYS_FULL = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] as const;

/** Monday-relative index: Mon=0, Tue=1, Wed=2, Thu=3, Fri=4, Sat=5, Sun=6 */
function mondayOffset(date: Date): number {
	return (date.getDay() + 6) % 7;
}

/**
 * Build a calendar grid starting on Monday.
 * Returns exactly `weeksNeeded * 7` Date objects covering the given month.
 */
export function buildCalendarGrid(year: number, month: number): { days: Date[]; weeksNeeded: number } {
	const firstOfMonth = new Date(year, month, 1);
	const startOffset = mondayOffset(firstOfMonth);
	const daysInMonth = new Date(year, month + 1, 0).getDate();
	const weeksNeeded = Math.ceil((startOffset + daysInMonth) / 7);

	const startDay = new Date(firstOfMonth);
	startDay.setDate(startDay.getDate() - startOffset);

	const days: Date[] = [];
	for (let i = 0; i < weeksNeeded * 7; i++) {
		const d = new Date(startDay);
		d.setDate(startDay.getDate() + i);
		days.push(d);
	}
	return { days, weeksNeeded };
}

/** Returns the Monday of the week containing `date`. */
export function getWeekStart(date: Date): Date {
	const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	d.setDate(d.getDate() - mondayOffset(d));
	return d;
}

/** Returns the 7 days Mon..Sun of the week starting on `monday`. */
export function getWeekDays(monday: Date): Date[] {
	const days: Date[] = [];
	for (let i = 0; i < 7; i++) {
		const d = new Date(monday);
		d.setDate(monday.getDate() + i);
		days.push(d);
	}
	return days;
}
